'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Actions


// Selectors


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _currentBoardIdActions = require('../reducers/currentBoardId/currentBoardIdActions');

var _navigationActions = require('../reducers/navigationActions');

var _currentBoardIdSelector = require('../reducers/currentBoardId/currentBoardIdSelector');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapStateToProps = function mapStateToProps(state) {
    return {
        stateCurrentBoardId: (0, _currentBoardIdSelector.getCurrentBoardId)(state)
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchCurrentBoardIdSet: function dispatchCurrentBoardIdSet(_ref) {
            var boardId = _ref.boardId;
            return dispatch((0, _currentBoardIdActions.currentBoardIdSet)({ boardId: boardId }));
        },
        dispatchUpdateUrl: function dispatchUpdateUrl(argObj) {
            return dispatch((0, _navigationActions.updateBoardSlug)(argObj));
        }
    };
};

var CurrentBoardIdSynchroniser = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(CurrentBoardIdSynchroniser, _React$Component);

    function CurrentBoardIdSynchroniser() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, CurrentBoardIdSynchroniser);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = CurrentBoardIdSynchroniser.__proto__ || Object.getPrototypeOf(CurrentBoardIdSynchroniser)).call.apply(_ref2, [this].concat(args))), _this), _this.updateCurrentBoardId = function (boardId) {
            var dispatchCurrentBoardIdSet = _this.props.dispatchCurrentBoardIdSet;

            dispatchCurrentBoardIdSet({ boardId: boardId });
        }, _this.updateUrl = function (_ref3) {
            var currentBoardId = _ref3.params.currentBoardId,
                routeParams = _ref3.routeParams,
                dispatchUpdateUrl = _ref3.dispatchUpdateUrl;

            if (!routeParams.slug) {
                dispatchUpdateUrl({ boardId: currentBoardId, routeParams: routeParams });
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CurrentBoardIdSynchroniser, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                currentBoardId = _props.params.currentBoardId,
                stateCurrentBoardId = _props.stateCurrentBoardId;


            if (currentBoardId) this.updateUrl(this.props);

            if (currentBoardId !== stateCurrentBoardId) {
                this.updateCurrentBoardId(currentBoardId);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var currentBoardId = nextProps.params.currentBoardId,
                stateCurrentBoardId = nextProps.stateCurrentBoardId;


            if (currentBoardId) this.updateUrl(nextProps);

            if (currentBoardId !== this.props.params.currentBoardId && currentBoardId !== stateCurrentBoardId) {
                this.updateCurrentBoardId(currentBoardId);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);

    return CurrentBoardIdSynchroniser;
}(_react2.default.Component)) || _class);


CurrentBoardIdSynchroniser.propTypes = {
    stateCurrentBoardId: _propTypes2.default.string,
    dispatchCurrentBoardIdSet: _propTypes2.default.func,
    dispatchUpdateUrl: _propTypes2.default.func,
    params: _propTypes2.default.object.isRequired,
    routeParams: _propTypes2.default.object.isRequired
};

exports.default = CurrentBoardIdSynchroniser;


//////////////////
// WEBPACK FOOTER
// ./src/client/app/CurrentBoardIdSynchroniser.js
// module id = 1667
// module chunks = 0